export enum TimeInForce {
    FillOrKill = 'FillOrKill',
    ImmediateOrCancel = 'ImmediateOrCancel',
}

export enum CryptoOrderTransaction {
    Buy = 'buy',
    Sell = 'sell',
}
